@import "../../../css/_mixins.scss";

.header {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;

  &.headerAuto {
    width: auto;
  }

  &.headerConstrained {
    width: 60vw;

    @include small-desktop {
      width: 92vw;
    }
    @include tablet {
      width: 100%;
    }
  }

  .headerRow {
    @media (min-width: 1000px) {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    // Below the desktop breakpoint, stack the search + filters cleanly
    // and center them inside the now-full-width container.
    @media (max-width: 999px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      width: 100%;
    }

    .dropdown-toggle {
      vertical-align: 0.05em;
      font-size: 1.8rem;
      color: var(--red);
    }
  }

  .inputSearch {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    border: 3px solid var(--red);
    border-radius: 25px;
    max-width: 280px;
    box-sizing: border-box;

    @media (max-width: 767px) {
      height: 48px;
      padding: 0 16px;
      width: 100%;
      max-width: 360px;
      margin-top: 0;
      margin-bottom: 0;
      position: relative;
    }

    .input {
      height: 100%;
      margin-left: 8px;
      font-size: 24px;
      font-weight: bold;
      color: var(--gray);
      border: none;
      max-width: 210px;
      min-width: 0;
      flex: 1;
      background: transparent;
      outline: none;
      @media (max-width: 767px) {
        width: 100%;
        max-width: none;
        height: 40px;
        font-size: 18px;
        text-align: left;
      }
    }

    i {
      font-size: 24px;
      color: var(--red);
      @media (max-width: 767px) {
        font-size: 20px;
        margin-left: 8px;
      }
    }
  }

  .filterWrapper {
    .filterTrigger {
      font-size: 22px;
      font-weight: bold;
      text-align: right;
      color: var(--yellow);
    }

    .filterList {
      width: 100%;
      max-height: 400px;
      overflow: auto;
      @media (max-width: 767px) {
        max-height: 160px;
        overflow-y: auto;
        position: absolute;
        left: 0;
        right: 0;
        z-index: 1;
      }

      .filterItem {
        padding: 4px 16px;
        font-size: 16px;
        color: var(--gray);
        cursor: pointer;

        &.clear {
          color: var(--red);
        }
      }
    }

    @media (max-width: 767px) {
      position: relative;
    }
  }
}

.checkMainCharities {
  margin-top: 16px;
}

.content {
  width: 100%;
  margin-top: 16px;

  .tip {
    color: var(--red);
    font-weight: bold;
    text-align: left;

    @media (max-width: 767px) {
      margin-top: 5%;
      margin-bottom: 5%;
      font-weight: bold;
      white-space: normal;
      vertical-align: middle;
      text-align: center;
      padding: 0 12px;
    }
  }

  .divFilters {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    label {
      padding: 5px;
      vertical-align: middle;
      font-size: 0.8em;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      margin-left: 16px;
      margin-right: 16px;
      gap: 4px;
      text-align: left;
    }
  }

  .charityList {
    height: 400px;
    margin-top: 8px;
    border: 1px solid var(--gray);
    color: var(--gray);
    border-radius: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 1100px) {
      position: relative;
    }
    @include tablet {
      height: auto;
      max-height: 60vh;
    }
    /* The original 30px-wide scrollbar ate ~10% of a phone's viewport. */
    &::-webkit-scrollbar {
      width: 14px;

      @include tablet {
        width: 8px;
      }
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background-color: var(--concrete);
      border-radius: 20px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: var(--yellow);
      border-radius: 20px;
      border: 2px solid var(--concrete);
    }

    .noResults {
      color: var(--red);
      font-weight: bold;
    }

    .charityItem {
      display: flex;
      align-items: center;
      margin: 16px 32px;
      -webkit-user-select: none;
      user-select: none;
      cursor: pointer;
      min-width: 0;

      @include tablet {
        margin: 12px 16px;
      }
      @include mobile {
        margin: 10px 10px;
      }

      .btnView {
        font-size: 16px;
        font-weight: bold;
        white-space: nowrap;
        flex-shrink: 0;
        @media (max-width: 767px) {
          font-size: 13px;
        }

        i {
          margin-right: 8px;
          @media (max-width: 767px) {
            margin-right: 4px;
          }
        }
      }

      .charityName {
        margin-left: 40px;
        font-size: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;

        @media (max-width: 767px) {
          font-size: 15px;
          margin-left: 16px;
          // Allow names to wrap onto two lines on phones instead of
          // ellipsis-truncating everything into unreadable stubs.
          white-space: normal;
          overflow: visible;
          text-overflow: clip;
          line-height: 1.25;
          word-break: break-word;
        }
        @include mobile {
          font-size: 14px;
          margin-left: 12px;
        }

        &.selected {
          color: var(--red);
          font-weight: bold;
        }
      }

      .iconSelected {
        margin-left: 16px;
        color: var(--red);
        font-size: 30px;
        flex-shrink: 0;
        @media (max-width: 767px) {
          font-size: 22px;
          margin-left: 8px;
        }
      }
    }
  }
}
